export const data = { content:"{\"info\":{\"title\":\"GuildLock API\",\"version\":\"1.0.0\",\"description\":\"API documentation for GuildLock, a Governance and Recovery solution for Discord communities.\",\"contact\":{\"name\":\"GuildLock Support\",\"url\":\"https://help.guildlock.com\"}},\"openapi\":\"3.1.1\",\"paths\":{},\"components\":{\"schemas\":{}},\"x-ext-urls\":{}}",
  parsed:{ info:{ title:"GuildLock API",
      version:"1.0.0",
      description:"API documentation for GuildLock, a Governance and Recovery solution for Discord communities.",
      contact:{ name:"GuildLock Support",
        url:"https://help.guildlock.com" } },
    openapi:"3.1.1",
    paths:{},
    components:{ schemas:{} },
    "x-ext-urls":{} } }